var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',{staticClass:"super-avatar avatar rounded-circle"},[(_vm.src)?_c('source',{attrs:{"srcset":_vm.avatarUrl}}):_vm._e(),_c('img',{staticClass:"super-avatar avatar rounded-circle",class:`avatar-${_vm.size}`,attrs:{"src":"/assets/images/illustration/super-twibbon-avatar.jpg","alt":"..."}})])
}
var staticRenderFns = []

export { render, staticRenderFns }